import {
  // Common actions
  UPDATE_TEAM_FILTER,
  UPDATE_IS_GIVING_FEEDBACK_ERROR,

  // Filter actions
  UPDATE_SEARCH_TEXT,
  UPDATE_APPLIED_FILTERS,
  UPDATE_FILTER_KEYS,
  UPDATE_GROUP_BY,
  UPDATE_PAGINATION,

  // Flag actions
  UPDATE_STATS_IS_DATA_LOADED,
  UPDATE_STATS_IS_LOADING,
  UPDATE_STATS_IS_BACKGROUND_LOADING,
  UPDATE_TABLE_IS_DATA_LOADED,
  UPDATE_TABLE_IS_LOADING,
  UPDATE_TABLE_IS_BACKGROUND_LOADING,

  // Stats data actions
  UPDATE_STATS_DATA,
  UPDATE_STATS_RAW_DATA,

  // Table data actions
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_COLUMNS,
  UPDATE_TABLE_RAW_DATA,

  // Reset actions
  RESET_GIVING_FEEDBACK_DATA,
  RESET_STATS_DATA,
  RESET_TABLE_DATA,
} from "./action";

// Common action creators
export const updateTeamFilter = (teamFilter) => {
  return {
    type: UPDATE_TEAM_FILTER,
    payload: { teamFilter },
  };
};

export const updateIsGivingFeedbackError = (isError) => {
  return {
    type: UPDATE_IS_GIVING_FEEDBACK_ERROR,
    payload: { isError },
  };
};

// Filter action creators
export const updateSearchText = (searchText) => {
  return {
    type: UPDATE_SEARCH_TEXT,
    payload: { searchText },
  };
};

export const updateAppliedFilters = (appliedFilters) => {
  return {
    type: UPDATE_APPLIED_FILTERS,
    payload: { appliedFilters },
  };
};

export const updateFilterKeys = (filterKeys) => {
  return {
    type: UPDATE_FILTER_KEYS,
    payload: { filterKeys },
  };
};

export const updateGroupBy = (groupBy) => {
  return {
    type: UPDATE_GROUP_BY,
    payload: { groupBy },
  };
};

export const updatePagination = (pagination) => {
  return {
    type: UPDATE_PAGINATION,
    payload: { pagination },
  };
};

// Stats flag action creators
export const updateStatsIsDataLoaded = (isDataLoaded) => {
  return {
    type: UPDATE_STATS_IS_DATA_LOADED,
    payload: { isDataLoaded },
  };
};

export const updateStatsIsLoading = (isLoading) => {
  return {
    type: UPDATE_STATS_IS_LOADING,
    payload: { isLoading },
  };
};

export const updateStatsIsBackgroundLoading = (isBackgroundLoading) => {
  return {
    type: UPDATE_STATS_IS_BACKGROUND_LOADING,
    payload: { isBackgroundLoading },
  };
};

// Table flag action creators
export const updateTableIsDataLoaded = (isDataLoaded) => {
  return {
    type: UPDATE_TABLE_IS_DATA_LOADED,
    payload: { isDataLoaded },
  };
};

export const updateTableIsLoading = (isLoading) => {
  return {
    type: UPDATE_TABLE_IS_LOADING,
    payload: { isLoading },
  };
};

export const updateTableIsBackgroundLoading = (isBackgroundLoading) => {
  return {
    type: UPDATE_TABLE_IS_BACKGROUND_LOADING,
    payload: { isBackgroundLoading },
  };
};

// Stats data action creators
export const updateStatsData = (data) => {
  return {
    type: UPDATE_STATS_DATA,
    payload: { data },
  };
};

export const updateStatsRawData = (rawData) => {
  return {
    type: UPDATE_STATS_RAW_DATA,
    payload: { rawData },
  };
};

// Table data action creators
export const updateTableData = (data) => {
  return {
    type: UPDATE_TABLE_DATA,
    payload: { data },
  };
};

export const updateTableColumns = (columns) => {
  return {
    type: UPDATE_TABLE_COLUMNS,
    payload: { columns },
  };
};

export const updateTableRawData = (rawData) => {
  return {
    type: UPDATE_TABLE_RAW_DATA,
    payload: { rawData },
  };
};

// Reset action creators
export const resetGivingFeedbackData = () => {
  return {
    type: RESET_GIVING_FEEDBACK_DATA,
  };
};

export const resetStatsData = () => {
  return {
    type: RESET_STATS_DATA,
  };
};

export const resetTableData = () => {
  return {
    type: RESET_TABLE_DATA,
  };
};
